import pinia from '@/store'
import { useConfigStore } from '@/store/config'

export function playSound(name: 'new' | 'new-version') {
  const config = useConfigStore(pinia)
  if (!config.mute) {
    const sound = new Audio(`${name}.mp3`)
    sound.play()
  }
}
